<template>
    <label
        class="btn"
        :class="[
          type && !disabled ? 'btn-' + type : '',
          size ? 'btn-' + size : '',
          block ? 'btn-' + block : '',
          {
              'disabled btn-default': disabled,
              'btn-danger': isChecked
          }
        ]">
        <!--<input :value="something" @input="something = $event.target.value">-->
        <input
            class="checkbox-button"
            type="checkbox"
            :name="name"
            v-model.trim="model"
            @change="handleChange"
            :value="label"
            :disabled="disabled">
        <i :class="'fa fa-fw fa-lg fa-' + icon" v-if="icon"></i>
        <span v-if="$slots.disabled && disabled "><slot name="disabled"></slot></span>
        <span v-if="$slots.default && ( !$slots.disabled || !disabled )"><slot></slot></span>
    </label>
</template>
<script>
    export default {
        name: 'EButtonCheckbox',
        props: {
            type: {
                type: String,
                default: function () {
                    return 'default';
                }
            },
            size: String,
            block: String,
            icon: {
                type: String,
                default: function () {
                    return '';
                }
            },
            disabled: Boolean,
            name: String,
            value: {},
            label: {}
        },
        data () {
            return {};
        },
        computed: {
            model: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.$emit('input', val);
                }
            },
            isChecked () {
                if (Array.isArray(this.model)) {
                    return this.model.indexOf(this.label) > -1;
                }
            }
        },
        methods: {
            handleChange (event) {
                this.$emit('change', event);
            }
        }
    };
</script>
<style rel="stylesheet/less">
    .checkbox-button {
        opacity: 0;
        outline: 0;
        position: absolute;
        z-index: -1;
        left: -999px;
    }
</style>



// WEBPACK FOOTER //
// src/plugin-api/packages/button/src/button-checkbox.vue